import React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import BankDetailsAddEdit from '../../pages/BankDetails/BankDetailsAddEdit';

export default function BankDetailsAddDialog({ isDialogOpened, handleCloseDialog }) {

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('lg');

    const handleClose = (data?: any) => {
        handleCloseDialog(data);
    };

    return (
        <React.Fragment>
            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={isDialogOpened}
                onClose={() => handleClose()}
                aria-labelledby="max-width-dialog-title"
            >
                <DialogTitle id="max-width-dialog-title">Bank Details</DialogTitle>
                <DialogContent>
                    <BankDetailsAddEdit dialog onClose={handleClose} />
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}